import { addSelectedCalendar } from 'owa-calendar-module-selected-calendars-user-config';
import { getDefaultCalendar } from 'owa-calendar-cache';

export function autoSelectDefaultCalendar(primarySmtpAddress: string) {
    const defaultCalendar = getDefaultCalendar(primarySmtpAddress);
    addSelectedCalendar(defaultCalendar.id.id, primarySmtpAddress);
}
